import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const filters = [
    {
      label: i18n.t("zone"),
      selectedOptions: null,
      placeholder: i18n.t("select"),
    },
    {
      label: i18n.t("sector"),
      selectedOptions: null,
      placeholder: i18n.t("select"),
    },
    {
        label: i18n.t("locations.type.SHELF"),
        selectedOptions: null,
        placeholder: i18n.t("select"),
    },
    {
        label: i18n.t("locations.type.LEVEL"),
        selectedOptions: null,
        placeholder: i18n.t("select"),
    },
  ];

  export default filters;
